__webpack_require__.p = "https://static.parastorage.com/services/restaurant-menus-showcase-ooi/5bd45e6088836ebbc537fdebc99d2ca5d091d21b6e7089ded608dded/";